export default "__VITE_ASSET__1R85PSvh__"